export default class MenuProducts
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    this.settings = {
      main: 'data-menu-product',
      desktop_description: 'data-menu-product-desktop-description',
      mobile_description: 'data-menu-product-mobile-description',
    };
    
    this.menuProducts = document.querySelectorAll(`[${this.settings.main}]`);
    if (!this.menuProducts) return;
    
    return true;
  }
  
  setEvents()
  {
    this.menuProducts.forEach((item) => {
      if (item.getAttribute(this.settings.main) != 'wybierz-produkt') {
        item.addEventListener('mouseenter', (e) => {
          const category = e.target.getAttribute(this.settings.main);
    
          this.menuProducts.removeClass('active');
          document.querySelectorAll(`[${this.settings.desktop_description}]`).removeClass('active');
    
          document.querySelector(`[${this.settings.main}="${category}"]`).addClass('active')
          document.querySelector(`[${this.settings.desktop_description}="${category}"]`).addClass('active')
        })
      }
    });
  }
}
